import { apiSlice } from "../../app/api/apiSlice"

// 定義工作許可證的數據類型
interface RiskAssessmentData {
    scheduleID: string;
}

export const RiskAssessmentSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        // 更新工作許可證
        updateRiskAssessment: builder.mutation<any, RiskAssessmentData>({
            query: (data) => ({
                url: `/WorkSchedule/${data.scheduleID}/RiskAssessment`,
                method: 'PUT',
                body: data,
            }),
            // 提供樂觀更新
            async onQueryStarted({ scheduleID }, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    // 可以在這裡添加成功後的處理邏輯
                } catch {
                    // 錯誤處理
                }
            },
        }),

        // 獲取工作許可證
        getRiskAssessment: builder.query<any, string>({
            query: (scheduleID) => ({
                url: `/WorkSchedule/${scheduleID}/RiskAssessment`,
            }),
        }),

        // 創建工作許可證
        createRiskAssessment: builder.mutation<any, RiskAssessmentData>({
            query: (data) => ({
                url: `/WorkSchedule/${data.scheduleID}/RiskAssessment`,
                method: 'PUT',
                body: data,
            }),
        }),

        // 刪除工作許可證
        deleteRiskAssessment: builder.mutation<any, string>({
            query: (scheduleID) => ({
                url: `/WorkSchedule/${scheduleID}/RiskAssessment`,
                method: 'DELETE',
            }),
        }),
    })
})

export const {
    useUpdateRiskAssessmentMutation,
    useGetRiskAssessmentQuery,
    useCreateRiskAssessmentMutation,
    useDeleteRiskAssessmentMutation,
} = RiskAssessmentSlice